import React from 'react';
import TenantFooter from './LandlordFooter';
import TenantHeader from './LandlordHeader';

interface LandlordLayoutProps {
  children: React.ReactNode;
  roleType?: string;
}

const LandlordLayout: React.FC<LandlordLayoutProps> = ({ children, roleType }) => (
  <div className="tenant-layout d-flex flex-column min-vh-100">
    <TenantHeader roleType={roleType ?? ""}/>
    <main className="py-30px">
      {children}
    </main>
    <TenantFooter />
  </div>
);

export default LandlordLayout;
